'use client';

import { getCookie } from '@/utils/cookies';
import { track } from '@smartproxy/sp-tracker-js';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export function ExperimentTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const loadExperiments = async () => {
      const experimentState: any = getCookie('bootstrapExperiments');

      if (experimentState) {
        const { experimentPaths, featureFlags } = experimentState;
        const flagId = experimentPaths?.[pathname];
        const variant = featureFlags?.[flagId];

        if (flagId && variant) {
          track('experiment_impression', {
            exp_experiment_id: flagId,
            variant_id: `${variant}`,
            exp_variant_id: variant === 'control' ? '0' : '1',
          });
        }
      }
    };

    loadExperiments();
  }, [pathname]);

  return null;
}
